module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-list"
    }
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true,
      "fixed": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.noForecasts) ? _c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.showRequiredActions) ? _c('RequiredActionsWidget', {
    attrs: {
      "show-spinner": false
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-forecasts-list"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isForecastManager || _vm.isZonesSupervisor) ? _c('div', {
    staticClass: "col-12 d-flex justify-content-end"
  }, [(_vm.isForecastManager) ? _c('DefaultButton', {
    attrs: {
      "size": 'l'
    },
    on: {
      "click": function($event) {
        _vm.$router.push(((_vm.ROUTES.BASE) + "/create"))
      }
    }
  }, [_vm._v("\n                        Create New Forecast\n                    ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row actions-header"
  }, [_c('div', {
    staticClass: "col-12 col-xl-9"
  }, [(_vm.isForecastManager || _vm.isZonesSupervisor || _vm.isForecastZoneLevel) ? [_c('ForecastFilters', {
    attrs: {
      "filter": _vm.isShowActiveOnly ? [_vm.FORECAST_STATUS.ACTIVE] : _vm.filter
    },
    on: {
      "click": _vm.makeFilter
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-xl-3"
  }, [((_vm.isForecastManager || _vm.isZonesSupervisor) && _vm.forecastSelected.length > 1) ? [_c('ForecastMultiSelected', {
    attrs: {
      "forecasts": _vm.forecastSelected
    },
    on: {
      "updateLoading": _vm.updateLoading
    }
  })] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "liste-forecasts",
    class: _vm.isForecastZoneLevel ? 'isForecastZoneLevel' : ''
  }, [_c('thead', [_c('tr', [(_vm.isForecastManager || _vm.isZonesSupervisor) ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "id",
    staticStyle: {
      "width": "50px",
      "max-width": "10%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "ref",
    staticStyle: {
      "width": "130px"
    }
  }, [_vm._v("ref.")]), _vm._v(" "), _c('th', {
    staticClass: "name",
    staticStyle: {
      "width": "20%",
      "min-width": "200px"
    }
  }, [_vm._v("name")]), _vm._v(" "), _c('th', {
    staticClass: "calendar",
    staticStyle: {
      "width": "20%",
      "min-width": "200px"
    }
  }, [_c('CalendarIcon', {
    attrs: {
      "color": '#5f5f60'
    }
  })], 1), _vm._v(" "), (_vm.isForecastManager || _vm.isZonesSupervisor) ? _c('th', {
    staticClass: "markets",
    staticStyle: {
      "min-width": "100px",
      "width": "10%"
    }
  }, [_c('WorldIcon', {
    attrs: {
      "color": '#5f5f60'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "items",
    staticStyle: {
      "min-width": "100px",
      "width": "10%"
    }
  }, [_vm._v("items")]), _vm._v(" "), _c('th', {
    staticClass: "approved",
    staticStyle: {
      "min-width": "100px",
      "width": "10%"
    }
  }, [_vm._v("approved")]), _vm._v(" "), (_vm.isForecastManager || _vm.isZonesSupervisor || _vm.isZoneReader) ? _c('th', {
    staticClass: "xls",
    staticStyle: {
      "min-width": "100px",
      "width": "10%"
    }
  }, [_vm._v("\n                            xls\n                        ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "70px",
      "width": "8%"
    }
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredForecasts), function(forecast) {
    return (_vm.isForecastManager || _vm.isZonesSupervisor) ? [_c('ForecastDetailBanner', {
      key: forecast.id,
      attrs: {
        "forecast": forecast,
        "forecastSelected": _vm.forecastSelected
      },
      on: {
        "check": _vm.checkForecast,
        "updateLoading": _vm.updateLoading
      }
    })] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.filteredForecastWindows), function(window) {
    return (_vm.isForecastZoneLevel) ? [_c('ForecastDetailBanner', {
      key: window.id,
      attrs: {
        "forecast": window.forecast,
        "forecastSelected": _vm.forecastSelected,
        "window": window,
        "display-xls-export": _vm.isZoneReader
      },
      on: {
        "updateLoading": _vm.updateLoading
      }
    })] : _vm._l((_vm.filteredForecastWindows), function(window) {
      return [_c('ForecastDetailBanner', {
        key: window.id,
        attrs: {
          "forecast": window.forecast,
          "forecastSelected": _vm.forecastSelected
        },
        on: {
          "updateLoading": _vm.updateLoading
        }
      })]
    })
  })], 2)])])]), _vm._v(" "), (_vm.noForecasts) ? _c('div', {
    staticClass: "no-forecast-message row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("No forecasts available")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bd54d7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/ForecastsList.vue
// module id = 3007
// module chunks = 0